export class CumulativeQuery {
  surname: string =""
  forename: string=""
  dob: string=""
  testCode: string=""
  //fromDate: Date
  //toDate: Date
}

